class PlaceholderHelpers {
    static getBadgeColor(data) {
        return data.source === 'system' && data.blocked ? 'purple' : data.blocked ? 'gray' : 'blue';
    }
}
export default PlaceholderHelpers;
